// This library offers an easy way to subscribe to online presence changes of a user
// via `subscribe` and `unsubscribe` methods.

// This offers a simpler API than `presence.onSync`, but importantly, `onSync`
// will only call the *last given callback*.

import { Presence } from "phoenix"
import userSocket from "./user_socket"

const OnlinePresence = {
  // The given callback will be called initially with the online presence of the user,
  // and then whenever it changes.
  // It returns a subscription object that should be passed to `unsubscribe` to stop listening.
  subscribe(userId, callback) {
    let lastState = null
    const fun = () => {
      const curState = this._isOnline(userId)
      if (lastState !== curState) {
        lastState = curState
        callback(curState)
      }
    }
    window.addEventListener("online-presence:refresh", fun)
    fun()
    return fun
  },

  // Pass the result of `subscribe` to stop received updates.
  unsubscribe(subscription) {
    window.removeEventListener("online-presence:refresh", subscription)
  },

  // Private
  _init() {
    this.channel = userSocket.channel("online_users:all", {})
    this.channel
      .join()
      .receive("ok", (resp) => {
        console.log("Joined successfully", resp)
      })
      .receive("error", (resp) => {
        console.log("Unable to join", resp)
      })

    this.presence = new Presence(this.channel)
    this.presence.onSync(() => this._sync())
  },

  _initNoSocket() {
    this.presence = { list: (fun) => [] }

    console.log("Online Presence disabled. This is normal within storybook/")
  },

  _sync() {
    window.dispatchEvent(new Event("online-presence:refresh"))
  },

  _isOnline(userId) {
    return this.presence.list((id, data) => id).includes(userId)
  },
}

if (userSocket) OnlinePresence._init()
else OnlinePresence._initNoSocket()

export default OnlinePresence
